// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3NqkG","checkboxCol":"Table_checkboxCol__1PsNs","emailCol":"Table_emailCol__AmzCH","actionCol":"Table_actionCol__2CFXP"};